import React, {useState, useEffect, useMemo, useLayoutEffect} from 'react'
import {useSelector} from 'react-redux'
import {useSearchParams, useLocation} from 'react-router-dom'
import {ThemeOptions, ThemeProvider} from '@mui/material'
import createCustomTheme from './themes'
import styleService from '../services/style.service'
import {RootState} from '../store_redux'
import demoCustomTheme from './custom_theme'
import utils from '../utils'

const useTheme = () => {
  const [customTheme, setCustomTheme] = useState<Partial<ThemeOptions> | null>(
    null,
  )
  const {pathname} = useLocation()
  const [searchParams] = useSearchParams()
  const orderGUID = searchParams.get('orderGUID') || ''
  const theme = useMemo(() => createCustomTheme(customTheme), [customTheme])

  // eslint-disable-next-line
  useEffect(() => {
    if (orderGUID) {
      const source = utils.generateCancelTokenSource()
      const config = {
        cancelToken: source.token,
      }
      if (utils.isWhiteListedPage(pathname)) {
        styleService
          .getStyles<Partial<ThemeOptions>>(orderGUID, config)
          .then(data => setCustomTheme(data))
          .catch(utils.routeToErrorPage)
      }
      return () => source.cancel()
    }
    // eslint-disable-next-line
  }, [orderGUID])

  // Only For DemoStyled Page - To Show the theme handler
  const demoMode = useSelector((state: RootState) => state.theme.mode)

  useLayoutEffect(() => {
    if (demoMode) {
      if (demoMode === 'DEFAULT') setCustomTheme(null)
      else setCustomTheme(demoCustomTheme)
    }
  }, [demoMode])

  //decide on the theme(custom/default) to return, till then return null. so that themes are applied only once.
  let themeToReturn = null;
  if (utils.isWhiteListedPage(pathname)) {
    if (customTheme) {
      themeToReturn = theme;
    }
  }
  else {
    themeToReturn = theme;
  }

  return themeToReturn;
}

const CustomThemeProvider: React.FC = function ({children}) {
  const theme = useTheme()
  return theme ?  <ThemeProvider theme={theme}>{children}</ThemeProvider> : null
}

export default CustomThemeProvider
